__turbopack_context__.v({
  "label": "GNoIpa_label",
  "row": "GNoIpa_row",
  "totalAmount": "GNoIpa_totalAmount",
});
